import { render, staticRenderFns } from "./Sense.vue?vue&type=template&id=61ed7465&scoped=true&"
import script from "./Sense.vue?vue&type=script&lang=js&"
export * from "./Sense.vue?vue&type=script&lang=js&"
import style0 from "./Sense.vue?vue&type=style&index=0&id=61ed7465&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ed7465",
  null
  
)

export default component.exports